const STORAGE_KEY = "ck-cinema-confirm"
const TTL_MS = 12 * 60 * 60 * 1000

type Stored = Record<string, number>

function read(): Stored {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? (JSON.parse(raw) as Stored) : {}
    } catch {
        return {}
    }
}

function write(data: Stored) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

/** Пользователь уже отвечал на вопрос про этот кинотеатр в последние сутки */
export function wasCinemaConfirmAnsweredRecently(cinemaId: number): boolean {
    const answeredAt = read()[String(cinemaId)]
    if (!answeredAt) return false
    return Date.now() - answeredAt < TTL_MS
}

/** Запомнить ответ на сутки */
export function markCinemaConfirmAnswered(cinemaId: number): void {
    const data = read()
    data[String(cinemaId)] = Date.now()
    write(data)
}
